"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubpageAssetProperty = exports.subpageAssetPropertyDefinition = void 0;
exports.subpageAssetPropertyDefinition = {
    view: { label: 'Asset' },
    constraints: [
        {
            name: 'stencils',
            argument: ['event-details'],
        },
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'asset',
    multiple: false,
    name: 'subpage-asset',
};
const isSubpageAssetProperty = (prop) => {
    return prop.name === exports.subpageAssetPropertyDefinition.name;
};
exports.isSubpageAssetProperty = isSubpageAssetProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VicGFnZS1hc3NldC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3N1YnBhZ2UtYXNzZXQucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFO0lBQ3hCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsZUFBZSxDQUFDO1NBQzVCO1FBQ0Q7WUFDRSxJQUFJLEVBQUUsVUFBVTtZQUNoQixRQUFRLEVBQUUsSUFBSTtTQUNmO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLGVBQWU7Q0FDVSxDQUFBO0FBSTFCLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxJQUFrQixFQUFnQyxFQUFFO0lBQ3pGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzQ0FBOEIsQ0FBQyxJQUFJLENBQUE7QUFDMUQsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQkFBc0IsMEJBRWxDIn0=